import {useEffect, useState} from "react";
import AdminSideBarItems from "./SideBarItems/AdminSideBarItems";
import ClientSideBarItems from "./SideBarItems/ClientSideBarItems";
import {getStoredUser, USER_STORAGE_UPDATED_EVENT} from "../utils";

export function getItem(label, key, icon, children) {
    return {
        key,
        icon,
        children,
        label,
    }
}

const SideBarItems = (t) => {
    const [isUserStaff, setIsUserStaff] = useState(false);

    useEffect(() => {
        const refreshUserPrivilege = () => {
            const items = getStoredUser();

            setIsUserStaff(Boolean(items?.data?.is_admin));
        };

        refreshUserPrivilege();
        window.addEventListener(USER_STORAGE_UPDATED_EVENT, refreshUserPrivilege);
        window.addEventListener('storage', refreshUserPrivilege);

        return () => {
            window.removeEventListener(USER_STORAGE_UPDATED_EVENT, refreshUserPrivilege);
            window.removeEventListener('storage', refreshUserPrivilege);
        };
    }, []);

    return (
        isUserStaff ? (
            AdminSideBarItems(t = {t})
        ) : (
            ClientSideBarItems(t = {t})
        )
    )
}

export default SideBarItems;
